if (!customElements.get('sticky-atc')) {
  class StickyATC extends HTMLElement {
    constructor() {
      super();
      this.buyButton = null;
      this.observer = null;
    }

    connectedCallback() {
      this.buyButton = document.querySelector('.product-form__submit');
      if (!this.buyButton) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
          });
        },
        { threshold: 0, rootMargin: '0px 0px -100px 0px' }
      );

      this.observer.observe(this.buyButton);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }

  customElements.define('sticky-atc', StickyATC);
}
